import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { RencanaAsuhanTerintegrasi } from "@/types/rencanaAsuhanTerintegrasi";

async function getByRegister(
  registerId: string | number
): Promise<RencanaAsuhanTerintegrasi> {
  const response = await http
    .getData(`/register/${registerId}/rencana-asuhan-terintegrasi`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data.data;
}

export default {
  getByRegister
};
